import { TEAM_TENNAT_API_URL } from './.env'
import { BaseService } from './base.service'
import { by } from './custom.service'

export class AuthService extends BaseService {
  // Login
  static login(data) {
    return new Promise((resolve, reject) => {
      return by(`${TEAM_TENNAT_API_URL}auth/login`, data)
        .then((response) => {
          // login successful if there's a jwt token in the response
          const data = {
            user: response?.data?.user,
            jwt: response?.data?.jwt,
            campuses: response?.data?.campuses || [],
            institute_title: response.data?.setting?.title,
            institute_counts: response?.data?.stats || null,
            setting: response?.data?.setting || null,
            generalSettings: response?.data?.general_feature_settings || null,
            institute: response?.data?.institute,
            students: response?.data?.students || [],
            sub_domain: response?.data?.sub_domain || null,
            is_pickup_assignee: response?.data?.is_pickup_assignee || null,
            guardian_info: response?.data?.guardian_info || null,
            disabled_features: response?.data?.disabled_features || [],
          }

          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('user', JSON.stringify(data.user))
          localStorage.setItem('selectedRoleId', response.data.user.user_roles[0].role_id)
          localStorage.setItem('pickupAssignee', JSON.stringify(data.is_pickup_assignee))
          resolve(this.responseWrapper(response, data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }

  static fetchOtpLoginData(data) {
    return new Promise((resolve, reject) => {
      return by(`${TEAM_TENNAT_API_URL}auth/login_otp`, data)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = error.response?.data?.message || error.message || 'OTP login failed'
          reject(this.errorWrapper(error, message))
        })
    })
  }
  // Sign out

  static signOut(payload) {
    return new Promise((resolve, reject) => {
      return by(`${TEAM_TENNAT_API_URL}/auth/logout`, payload)
        .then((response) => {
          resolve(this.responseWrapper(response, response?.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }

  static getUserRegistrationStatus(payload) {
    return new Promise((resolve, reject) => {
      return by(`${TEAM_TENNAT_API_URL}registration_status`, payload)
        .then((response) => {
          resolve(this.responseWrapper(response, response?.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }

  static resendRegistrationEmail(payload) {
    return new Promise((resolve, reject) => {
      return by(`${TEAM_TENNAT_API_URL}signup_institute/resend_email`, payload)
        .then((response) => {
          resolve(this.responseWrapper(response, response?.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }

  // Get user domains

  static fetchUserDomains(data) {
    return new Promise((resolve, reject) => {
      return by(`${TEAM_TENNAT_API_URL}/auth/user_sub_domains`, data)
        .then((response) => {
          resolve(this.responseWrapper(response, response?.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }
}
